module.exports = __webpack_public_path__ + "img/Identity-Pattern1.e0b12fbd.jpg";